import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';
import { OKTA_LOGIN_PAGE } from 'src/context/auth/types';
//** Context */
import useAuth from 'src/hooks/useAuth';
import useBackListener from 'src/hooks/useBackListener.ts';
import usePreQualificationPages from 'src/hooks/usePreQualificationPages';
//* ----------------------------------------------------------------

export default function CCPageGuard({ children }) {
  const { pathname } = useLocation();
  const { funcs } = usePreQualificationPages();
  const { getOktaAccessToken, setAuthenticationDetails } = useAuth();

  // !! Check to ensure that we can go to a specific page
  // !! If the page is valid or the  page is next in the page sequence, allow access
  // !! else return to the last valid page.

  // ? Get this from the Pages Context - Pass in the index of the page we are trying to access
  const pageIndex = { ...children }.props.pageIndex;

  useEffect(() => {
    async function initialize() {
      try {
        let oktaAccessToken = await getOktaAccessToken();
        if (oktaAccessToken) {
          setAuthenticationDetails(true);
        } else {
          //not a valid OKta Access token redirect to the okta login page
          window.location.href = OKTA_LOGIN_PAGE;
        }
      } catch (err) {
        console.error('Error occurred while calling Okta library - ', err);
      }
    }
    initialize();
  }, [pathname]);

  const navType = useBackListener();
  // Ensure we are allowed to navigate to the requested page
  const responsePage = funcs.getRequestPage({
    requestPageIndex: pageIndex,
    navType: navType,
  });
  // Check if this is a navigation 'back'
  if (responsePage.allowPageRequest === false || responsePage.isBack === true) {
    return <Navigate to={responsePage.responsePage.previousRoutePath} />;
  }

  // No issue, load the page.
  return <>{children}</>;
}
